// frontend/src/components/DocumentCard.js

// import React from 'react';
// import { Card, CardActionArea, CardContent, Typography, Chip, Box } from '@mui/material';
// import { useNavigate } from 'react-router-dom'; // ### PASSO 1: IMPORTE O useNavigate ###

// const DocumentCard = ({ document }) => {
//   const navigate = useNavigate(); // ### PASSO 2: INICIALIZE O HOOK ###

//   const getStatusChip = (status) => {
//     const statusMap = {
//       'PENDENTE': { label: 'Pendente', color: 'warning' },
//       'EM_COLETA': { label: 'Em Coleta', color: 'info' }, // Chave corrigida
//       'CONCLUIDO': { label: 'Concluído', color: 'success' },
//       'RECUSADO': { label: 'Recusado', color: 'error' },
//     };
//     const { label, color } = statusMap[status] || { label: status, color: 'default' };
//     return <Chip label={label} color={color} size="small" sx={{ fontWeight: 'bold' }}/>;
//   };

//   const handleCardClick = () => {
//     // Agora a função 'navigate' existe e funcionará corretamente.
//     navigate(`/documento/${document.id}`);
//   };

//   return (
//     <Card elevation={2} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
//       <CardActionArea onClick={handleCardClick} sx={{ flexGrow: 1 }}>
//         <CardContent>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
//             <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1, flexGrow: 1, pr: 1 }} title={document.descricao}>
//               {document.descricao}
//             </Typography>
//             {getStatusChip(document.status)}
//           </Box>
//           <Typography variant="body2" color="text.secondary">
//             Enviado por: {document.servidor_que_enviou_nome}
//           </Typography>
//           <Typography variant="caption" color="text.secondary">
//             Criado em: {new Date(document.criado_em).toLocaleString('pt-BR')}
//           </Typography>
//         </CardContent>
//       </CardActionArea>
//     </Card>
//   );
// };

// export default DocumentCard;


import React, { useState } from 'react';
import {
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Box,
  LinearProgress,
  Chip,
  Tooltip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
  CircularProgress,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { deleteDocument } from '../services/api';
import { useNotification } from '../context/NotificationContext';

const DocumentCard = ({ document, onDelete }) => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useNotification();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const {
    id,
    descricao = 'Sem descrição',
    status = 'Desconhecido',
    pedidos_assinatura: signers = [],
    criado_em,
  } = document;

  const signedCount = signers.filter(s => s.status === 'ASSINADO').length;
  const totalSigners = signers.length;
  const progress = totalSigners > 0 ? (signedCount / totalSigners) * 100 : 0;

  const formattedDate = criado_em 
    ? new Date(criado_em).toLocaleDateString('pt-BR')
    : '--';

  const getDocumentStatusChip = (docStatus) => {
    const statusMap = {
      EM_COLETA: { label: 'Em Coleta', color: 'info' },
      CONCLUIDO: { label: 'Concluído', color: 'success' },
      ARQUIVADO: { label: 'Arquivado', color: 'default' },
      RASCUNHO: { label: 'Rascunho', color: 'secondary' },
    };
    const { label = docStatus, color = 'default' } = statusMap[docStatus] || {};
    return <Chip label={label} color={color} size="small" />;
  };

  const handleCardClick = () => {
    navigate(`/documento/${id}`); 
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    setConfirmOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      setIsDeleting(true);
      await deleteDocument(id);
      setConfirmOpen(false);
      showSuccess(`Documento "${descricao}" excluído definitivamente.`);
      if (onDelete) {
        onDelete(id);
      }
    } catch (err) {
      console.error('Erro ao excluir documento:', err);
      showError('Não foi possível excluir o documento. Tente novamente.');
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <Card sx={{ position: 'relative', height: '100%' }}>
        <Tooltip title="Excluir documento">
          <IconButton
            size="small"
            aria-label="Excluir documento"
            onClick={handleDeleteClick}
            sx={{
              position: 'absolute',
              top: 10,
              right: 10,
              zIndex: 2,
              color: 'text.secondary',
              '&:hover': {
                color: 'error.main',
                backgroundColor: 'rgba(211, 47, 47, 0.08)',
              },
            }}
          >
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip>

        <CardActionArea onClick={handleCardClick} sx={{ height: '100%' }}>
          <CardContent sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h6" component="h2" gutterBottom sx={{ pr: 4, wordBreak: 'break-word' }}>
                {descricao}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary', mb: 2 }}>
                <AccessTimeIcon sx={{ fontSize: '1rem', mr: 0.5 }} />
                <Typography variant="caption">Criado em: {formattedDate}</Typography>
              </Box>
            </Box>
            
            <Box>
              <Typography variant="body2" color="text.secondary">
                Progresso: {signedCount} de {totalSigners}
              </Typography>
              <LinearProgress variant="determinate" value={progress} sx={{ height: 8, borderRadius: 4, mb: 1 }} />
              {getDocumentStatusChip(status)}
            </Box>
          </CardContent>
        </CardActionArea>
      </Card>

      <Dialog
        open={confirmOpen}
        onClose={() => !isDeleting && setConfirmOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'error.main', fontWeight: 700 }}>
          <WarningAmberRoundedIcon color="error" />
          Excluir Documento Definitivamente?
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Você está prestes a excluir o documento <strong>"{descricao}"</strong> da sua lista.
          </Typography>
          <Alert severity="error" variant="outlined" sx={{ mb: 1 }}>
            <strong>Atenção:</strong> Esta ação é irreversível! Ao confirmar, você <strong>perderá definitivamente</strong> este documento e todo o histórico de assinaturas do sistema.
          </Alert>
          {status === 'CONCLUIDO' ? (
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1.5 }}>
              Certifique-se de que você já realizou o download do arquivo PDF assinado antes de excluí-lo.
            </Typography>
          ) : (
            <Typography variant="caption" color="warning.dark" sx={{ display: 'block', mt: 1.5, fontWeight: 500 }}>
              Este documento ainda está com status "{status === 'EM_COLETA' ? 'Em Coleta' : status}". Os assinantes pendentes não poderão mais assiná-lo.
            </Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={() => setConfirmOpen(false)}
            disabled={isDeleting}
            variant="outlined"
            color="inherit"
          >
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmDelete}
            disabled={isDeleting}
            variant="contained"
            color="error"
            startIcon={isDeleting ? <CircularProgress size={18} color="inherit" /> : <DeleteForeverIcon />}
          >
            {isDeleting ? 'Excluindo...' : 'Excluir Definitivamente'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DocumentCard;